/* eslint-disable strict */

'use strict';

(function ProductSpecifications() {
  $('[data-js-collapsible="product_specifications"]').on('click', expand);

  function expand() {
    var instances;
    if (underBreakpoint()) return;

    instances = Simba.Collapsible.filter(function findByName(instance) {
      return instance.instanceName === 'product_specification_detail' && !instance.isExpanded();
    });

    instances.forEach(function setInstanceState(instance) {
      instance.expand();
    });
  }

  function underBreakpoint() {
    return !window.matchMedia('(min-width: 840px)').matches;
  }
})();
